import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import App from './App.vue';
import router from './router';
import store from './store';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHeart,
  faSpinner,
  faCheckCircle,
  faStar
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import {
  faHeart as farHeart,
  faCheckCircle as farCheckCircle,
  faStar as farStar
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { getCookie } from './utils/helpers';

const path = process.env.VUE_APP_ROOT_API;

library.add(
  faHeart,
  faSpinner,
  faCheckCircle,
  farCheckCircle,
  farHeart,
  faStar,
  farStar
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.clear

  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  // eslint-disable-next-line
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(
    el => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://723dde25eadb480dbd0532b9f31de782@sentry.io/1476057',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

const token = getCookie('token');

axios.defaults.baseURL = path;
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': path,
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`,
};

if (window.Cypress) {
  // only available during E2E tests
  window.app = app;
}
